import {
  Eq,
  Expression,
  Relation,
  From,
  GenUuid,
  IsNull,
  AST,
} from '@cotera/era';
import { SYSTEM_TABLES } from '../../runtime/system-tables';
import { EventStreamDefinition } from '../../manifest';
import { streamSpecifierToEventStreamIds } from '../../builder/stream-specifier-to-event-stream-ids';

export const MissingEventStreamStableIds = (params: {
  SYSTEM_TABLES?: Partial<
    Record<keyof typeof SYSTEM_TABLES, AST.TableDescription | Relation>
  >;
  eventStream: Pick<EventStreamDefinition, 'identifier' | 'rel' | 'specifier'>;
}): Relation => {
  const { eventStream } = params;
  const rel = Relation.fromAst(eventStream.rel);
  const { entityName } = streamSpecifierToEventStreamIds(eventStream.specifier);

  const StableIdsForEntity = From(
    params.SYSTEM_TABLES?.stable_ids ?? SYSTEM_TABLES.stable_ids
  ).where((t) => Eq(t.attr('definition_id'), entityName));

  const Target = rel.select(
    (_t) => ({
      identifier: Expression.fromAst(eventStream.identifier).cast('string'),
    }),
    { distinct: true }
  );

  const NewIds = Target.leftJoin(StableIdsForEntity, (target, stableIds) => ({
    on: Eq(
      target.attr('identifier').cast('string'),
      stableIds.attr('identifier').cast('string')
    ),
    select: {
      ...target.pick('identifier'),
      __stable_identifier: stableIds.attr('identifier'),
    },
  }))
    .where((t) => IsNull(t.attr('__stable_identifier')))
    .select((t) => ({
      ...t.pick('identifier'),
      definition_id: entityName,
      cotera_stable_id: GenUuid(),
    }));

  return NewIds;
};
